import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Video, Building2, Users } from "lucide-react";
import { api } from "../../lib/api";

const fmt = (iso) => {
    if (!iso) return "—";
    const d = new Date(iso);
    if (isNaN(d.getTime())) return "—";
    return d.toLocaleString("it-IT", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
};

export default function PortalRiunioni() {
    const navigate = useNavigate();
    const [filter, setFilter] = useState("upcoming");
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchList = useCallback(async () => {
        setLoading(true);
        try {
            const { data } = await api.get("/client/meetings", { params: { filter, limit: 100 } });
            setItems(data.items || []);
        } catch { toast.error("Errore caricamento"); } finally { setLoading(false); }
    }, [filter]);
    useEffect(() => { fetchList(); }, [fetchList]);

    const now = Date.now();

    return (
        <div className="lt-page" data-testid="portal-riunioni-page">
            <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 20 }}>
                <h1 className="lt-h1" style={{ margin: 0 }}>Riunioni</h1>
                <div style={{ flex: 1 }} />
                <div className="lt-segmented" data-testid="portal-riunioni-filter">
                    <button type="button" className={"lt-segmented__btn" + (filter === "upcoming" ? " is-active" : "")} onClick={() => setFilter("upcoming")}>In arrivo</button>
                    <button type="button" className={"lt-segmented__btn" + (filter === "past" ? " is-active" : "")} onClick={() => setFilter("past")}>Passate</button>
                </div>
            </div>

            <div className="lt-card" style={{ padding: 0 }}>
                <table className="lt-table" data-testid="portal-riunioni-table">
                    <thead>
                        <tr>
                            <th>Titolo</th>
                            <th style={{ width: 200 }}>Quando</th>
                            <th style={{ width: 100 }}>Partec.</th>
                            <th style={{ width: 140 }}></th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? <tr><td colSpan={4} style={{ padding: 24, color: "#8A8F88" }}>Caricamento…</td></tr>
                            : items.length === 0 ? <tr><td colSpan={4} style={{ padding: 24, color: "#8A8F88" }} data-testid="portal-riunioni-empty">Nessuna riunione.</td></tr>
                                : items.map(m => {
                                    const endMs = m.datetime_end ? new Date(m.datetime_end).getTime() : 0;
                                    const canJoin = endMs >= now;
                                    return (
                                        <tr key={m.id} data-testid={`portal-meeting-row-${m.id}`}>
                                            <td>
                                                <div style={{ fontWeight: 500, color: "#181B20" }}>{m.title}</div>
                                                {m.description && <div style={{ color: "#8A8F88", fontSize: 12 }}>{m.description.slice(0, 80)}</div>}
                                            </td>
                                            <td style={{ fontSize: 13 }}>{fmt(m.datetime_start)}</td>
                                            <td style={{ color: "#5F6560" }}><Users size={12} /> {(m.participants_internal || []).length}</td>
                                            <td style={{ textAlign: "right" }}>
                                                {canJoin && (
                                                    <button type="button" className="lt-btn-primary" style={{ fontSize: 12, padding: "4px 10px" }} onClick={() => navigate(`/portal/riunioni/${m.id}/join`)} data-testid={`portal-meeting-join-${m.id}`}>
                                                        <Video size={12} /> Partecipa
                                                    </button>
                                                )}
                                            </td>
                                        </tr>
                                    );
                                })}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
